import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RecentActivity = () => {
  const recentJobs = [
  {
    id: 1,
    name: "Miniatura de Dragão",
    printer: "Ender 3 Pro",
    status: "completed",
    duration: "4h 32m",
    cost: "R$ 12,50",
    filament: "PLA Vermelho",
    startTime: "2025-11-01T06:00:00",
    image: "https://images.unsplash.com/photo-1659985834287-8fb170934642",
    imageAlt: "Detailed red dragon miniature figurine with intricate scales and wings on white background"
  },
  {
    id: 2,
    name: "Suporte para Celular",
    printer: "Prusa i3 MK3S+",
    status: "printing",
    duration: "2h 15m",
    cost: "R$ 8,75",
    filament: "PETG Azul",
    startTime: "2025-11-01T08:15:00",
    progress: 65,
    image: "https://images.unsplash.com/photo-1569508177734-8d8f0c96c241",
    imageAlt: "Modern blue smartphone stand holder with curved design on wooden desk surface"
  },
  {
    id: 3,
    name: "Vaso Decorativo",
    printer: "Artillery X1",
    status: "queued",
    duration: "6h 45m",
    cost: "R$ 18,90",
    filament: "PLA+ Branco",
    startTime: "2025-11-01T14:30:00",
    image: "https://images.unsplash.com/photo-1730370435391-95424aedba74",
    imageAlt: "Elegant white decorative vase with geometric spiral pattern and smooth finish"
  }];


  const getStatusConfig = (status) => {
    const configs = {
      completed: {
        color: 'text-success',
        bgColor: 'bg-success/10',
        icon: 'CheckCircle',
        label: 'Concluído'
      },
      printing: {
        color: 'text-primary',
        bgColor: 'bg-primary/10',
        icon: 'Play',
        label: 'Imprimindo'
      },
      queued: {
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        icon: 'Clock',
        label: 'Na Fila'
      }
    };
    return configs?.[status] || configs?.queued;
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date?.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Atividade Recente</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          Ver Todos
        </button>
      </div>
      <div className="space-y-4">
        {recentJobs?.map((job) => {
          const statusConfig = getStatusConfig(job?.status);

          return (
            <div
              key={job?.id}
              className="flex items-center space-x-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors cursor-pointer">

              {/* Job Image */}
              <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                <Image
                  src={job?.image}
                  alt={job?.imageAlt}
                  className="w-full h-full object-cover" />

              </div>
              {/* Job Details */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-medium text-foreground truncate">{job?.name}</h3>
                  <span className="text-sm font-medium text-foreground">{job?.cost}</span>
                </div>
                
                <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                  <span className="flex items-center space-x-1">
                    <Icon name="Printer" size={14} />
                    <span>{job?.printer}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <Icon name="Clock" size={14} />
                    <span>{job?.duration}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <Icon name="Filament" size={14} />
                    <span>{job?.filament}</span>
                  </span>
                </div>

                {/* Progress Bar for Printing Jobs */}
                {job?.status === 'printing' && job?.progress &&
                <div className="mt-2">
                    <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                      <span>Progresso</span>
                      <span>{job?.progress}%</span>
                    </div>
                    <div className="w-full bg-muted rounded-full h-2">
                      <div
                      className="bg-primary rounded-full h-2 transition-all duration-300"
                      style={{ width: `${job?.progress}%` }} />

                    </div>
                  </div>
                }
              </div>
              {/* Status Badge */}
              <div className={`flex items-center space-x-2 px-3 py-1 rounded-full ${statusConfig?.bgColor}`}>
                <Icon name={statusConfig?.icon} size={14} className={statusConfig?.color} />
                <span className={`text-xs font-medium ${statusConfig?.color}`}>
                  {statusConfig?.label}
                </span>
              </div>
            </div>);

        })}
      </div>
    </div>);

};

export default RecentActivity;
